import { useRoute } from 'nuxt/app';
import { isBoutiquePath, isLoyaltyOfferPath, isSearchPath, isShortListPath } from '~~/common/utils/pageType';

export default {
  computed: {
    isHomePage () {
      const route = useRoute();
      return route.path.split('/').length === 2;
    },
    isProductListPage () {
      const route = useRoute();
      return this.isPathIsProductListPage(route.path);
    },
    isProductDetailsPage () {
      const route = useRoute();
      return /.*?\.p-([0-9]+)/gi.test(route.path);
    },
    isSearchPage () {
      const route = useRoute();
      return isSearchPath(route);
    },
    isBoutique () {
      const route = useRoute();
      return isBoutiquePath(route);
    },
    isShortList () {
      const route = useRoute();
      return isShortListPath(route);
    },
    isLoyaltyOffer () {
      const route = useRoute();
      return isLoyaltyOfferPath(route);
    },
    isPreviouslyOrderedProducts () {
      const route = useRoute();
      return /.*?\/order-again/gi.test(route.path);
    },
    isFaqPage () {
      const route = useRoute();
      return /.*?\/faq|.*?\/gyik/gi.test(route.path);
    },
    isCareerPage () {
      const route = useRoute();
      return /.*?\/karrier/gi.test(route.path);
    },
    isSdsPage () {
      const route = useRoute();
      return /.*?\/(safety-data-sheet|biztonsagi-adatlapok)/gi.test(route.path);
    },
  },
  methods: {
    isPathIsProductListPage (path) {
      return /.*?\.c-([0-9]+)/gi.test(path);
    },
  },
};
